import PropTypes from "prop-types";

const Toolbar = ({ selectedList, actions }) => {
	return (
		<>
			{selectedList?.length > 0 && (
				<div className="data-table3__table__head__row secondary">
					<span className="DS__items-selected">
						{selectedList.length}{" "}
						{selectedList.length > 1 ? "items" : "item"} selected
					</span>
					{actions}
				</div>
			)}
		</>
	);
};

Toolbar.propTypes = {
	selectedList: PropTypes.array,
	actions: PropTypes.node,
};

export default Toolbar;
